



























import {Component, Vue, Prop} from "vue-property-decorator";
import {namespace} from "vuex-class";
import LoadingDroppo from "@/views/components/LoadingDroppo.vue";
import {IHub} from '@/models/StoreModels';
import {ANALYTIC_ROUTING} from "@/services/Analytics";
import {OTHER_ROUTES} from "@/constants/routes";

const shipmentStore = namespace("shipment"); // todo: maybe we should get this from other store (active orders?)
const hubsStore = namespace("hubs");

@Component({
  name: 'FinishAndOpen',
  components: {
    LoadingDroppo,
  },
})
export default class FinishAndOpen extends Vue {
  @Prop()
  private asId!: number;

  private finish: boolean = true;

  @shipmentStore.Getter("getFromHubId")
  private sGetFromHubId!: number;

  @shipmentStore.Action("reset")
  private resetShippingStore!: () => void;

  @shipmentStore.Getter("getSizeHumanReadable")
  private getSizeHumanReadable!: number;

  @hubsStore.Getter('getHubById')
  private getHubById!: (id: number) => IHub;

  get selectedHub(): IHub {
    return this.getHubById(this.sGetFromHubId);
  }

  private created() {
    ANALYTIC_ROUTING.exitCrossTown(this.$gtag);
  }

  private openHub() {
    this.$router.push({
      name: OTHER_ROUTES.DEPOSIT_ITEM,
      params: {asId: `${this.asId}`},
    });
    this.resetShippingStore();
  }

  private goHome() {
    this.$router.push({ name: OTHER_ROUTES.HOME });
    this.resetShippingStore();
  }
}
